import { render, staticRenderFns } from "./rate-config.vue?vue&type=template&id=9ae0bf84"
import script from "./rate-config.vue?vue&type=script&lang=ts"
export * from "./rate-config.vue?vue&type=script&lang=ts"
import style0 from "./rate-config.vue?vue&type=style&index=0&id=9ae0bf84&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports